import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateSchoolLoginPassword } from '../../service/accessCodesService';
import './AccessCode.css';
import FidgetLoader from '../FidgetLoader';

function SchoolLogin() {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // No Auth0 token needed for school password verification
            const res = await validateSchoolLoginPassword(password);
            if (res && res.data && res.data.valid) {
                sessionStorage.setItem('schoolPasswordVerified', 'true');
                setLoading(false);
                navigate('/members');
            } else if (res && res.data && res.data.valid === false) {
                setLoading(false);
                setError(res.data.message || 'Invalid password. Please try again.');
            } else {
                setLoading(false);
                setError('There was a problem. Please try again.');
            }
        } catch (err) {
            setLoading(false);
            if (err.message) {
                setError(err.message);
            } else {
                setError('There was a problem. Please try again.');
            }
        }
    };

    if (loading) {
        return (
            <div className="fidget__container">
                <FidgetLoader />
            </div>
        );
    }

    return (
        <div className="login__outer-container">
            <div className="login__inner-container">
                <div className="contact__heading">Members Login</div>
                <div className="contact__form-container">
                    <div className="contact__message">
                        Please enter your provided password to verify your access.
                        {error && (
                            <p className="error" style={{ color: '#ff5b14' }}>
                                *
                                {error}
                            </p>
                        )}
                    </div>
                    <form className="contact__form" onSubmit={handleSubmit}>
                        <div className="contact__label-container">
                            <h3>Password:</h3>
                        </div>
                        <input
                            id="password"
                            className="text-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                            disabled={loading} />
                        <div className="contact__submit-container">
                            <button
                                className="contact__submit-button"
                                type="submit"
                                disabled={loading}>
                                Log In
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SchoolLogin;
